export default function CaretUp({fill = 'white'}) {
  return (
    <svg style={{padding: "4px"}} width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M5.6315 4.13152L1.8105 0.310524C1.3965 -0.103477 0.7245 -0.103477 0.3105 0.310524C-0.1035 0.724524 -0.1035 1.39652 0.3105 1.81052L4.9245 6.42452C5.3155 6.81552 5.9485 6.81552 6.3385 6.42452L10.9525 1.81052C11.3665 1.39652 11.3665 0.724524 10.9525 0.310524C10.5385 -0.103477 9.8665 -0.103477 9.4525 0.310524L5.6315 4.13152Z" fill="white"/>
    </svg>
  )
}

